'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

exports.MilestoneState = void 0;
(function (MilestoneState) {
    MilestoneState["MILESTONE_STATE_INVALID"] = "MILESTONE_STATE_INVALID";
    MilestoneState["MILESTONE_STATE_LOCKED"] = "MILESTONE_STATE_LOCKED";
    MilestoneState["MILESTONE_STATE_INTERMEDIATE"] = "MILESTONE_STATE_INTERMEDIATE";
    MilestoneState["MILESTONE_STATE_UNLOCKED"] = "MILESTONE_STATE_UNLOCKED";
    MilestoneState["MILESTONE_STATE_USED"] = "MILESTONE_STATE_USED";
    MilestoneState["MILESTONE_STATE_EXPIRED"] = "MILESTONE_STATE_EXPIRED";
})(exports.MilestoneState || (exports.MilestoneState = {}));
exports.DiscoverMilestoneWidgetViewType = void 0;
(function (DiscoverMilestoneWidgetViewType) {
    DiscoverMilestoneWidgetViewType["DISCOVER_MILESTONE_WIDGET_VIEW_TYPE_INVALID"] = "DISCOVER_MILESTONE_WIDGET_VIEW_TYPE_INVALID";
    DiscoverMilestoneWidgetViewType["DISCOVER_MILESTONE_WIDGET_VIEW_TYPE_HORIZONTAL"] = "DISCOVER_MILESTONE_WIDGET_VIEW_TYPE_HORIZONTAL";
    DiscoverMilestoneWidgetViewType["DISCOVER_MILESTONE_WIDGET_VIEW_TYPE_VERTICAL"] = "DISCOVER_MILESTONE_WIDGET_VIEW_TYPE_VERTICAL";
})(exports.DiscoverMilestoneWidgetViewType || (exports.DiscoverMilestoneWidgetViewType = {}));
exports.AnimationType = void 0;
(function (AnimationType) {
    AnimationType["ANIMATION_TYPE_INVALID"] = "ANIMATION_TYPE_INVALID";
    AnimationType["ANIMATION_TYPE_MILESTONE_UNLOCKED"] = "ANIMATION_TYPE_MILESTONE_UNLOCKED";
})(exports.AnimationType || (exports.AnimationType = {}));
//# sourceMappingURL=type.js.map
